import { render, staticRenderFns } from "./OtpSms.vue?vue&type=template&id=2369dfa5&"
import script from "./OtpSms.vue?vue&type=script&lang=js&"
export * from "./OtpSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports